import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { SPEEDOMETER_HEALTH_MONITORING_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { SPEEDOMETER_HEALTH_MONITORING_REPORT } from "../interfaces/dashboard";

export default function SpeedometerHealthMonitoring() {
    const speedometerHealthMonitoringReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.SPEEDOMETER_HEALTH_MONITORING_REPORT;

    const [speedometerHealthMonitoringReportTableData, setSpeedometerHealthMonitoringReportTableData] = useState<SPEEDOMETER_HEALTH_MONITORING_REPORT[]>([]);

    useEffect(() => {
        setSpeedometerHealthMonitoringReportTableData(SPEEDOMETER_HEALTH_MONITORING_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="SPEEDOMETER_HEALTH_MONITORING"
        tableColumns={speedometerHealthMonitoringReportTableColumns}
        tableData={speedometerHealthMonitoringReportTableData} />
    );
}